export default {
  outfitsList: state => state.outfits,
};
